import { contact } from '../../data/portfolio'
import useGoogleAnalytics, { trackingId } from '../../hooks/useGoogleAnalytics';
import './Contact.scss'

const Contact: React.FC = () => {
  const { trackEvent } = useGoogleAnalytics();

  if (!contact.email) return null

  const sendGAContactEvent = () => {
    if (trackingId) {
      try {
        trackEvent('Contact', 'Email Click', 'User clicked on email button');
      } catch (error) {
        console.log("Error executing trackEvent Google Analytics", { Error: error });
      }
    }
  };

  return (
    <section className='section contact center' id='contact'>
      <h2 className='section__title'>Contact</h2>
      <a href={`mailto:${contact.email}`}>
        <button type='button' className='btn btn--outline' onClick={sendGAContactEvent}>
          Email me
        </button>
      </a>
    </section>
  )
}

export default Contact
